import React from "react";
const IconAlert = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8 2a1 1 0 0 1 1 1v.05a1 1 0 1 1-2 0V13a1 1 0 0 1 1-1ZM9 6v5h2V6H9Z"
      fill="currentColor"
    />
  </svg>
);
export default IconAlert;
